//#region src/maitred_activity_update_type.ts
var MaitredActivityUpdateType = /* @__PURE__ */ function(MaitredActivityUpdateType) {
	MaitredActivityUpdateType["Changeset"] = "changeset";
	MaitredActivityUpdateType["Clone"] = "clone";
	MaitredActivityUpdateType["EightySix"] = "eighty-six";
	MaitredActivityUpdateType["MagicCopy"] = "magic-copy";
	return MaitredActivityUpdateType;
}(MaitredActivityUpdateType || {});
//#endregion
export { MaitredActivityUpdateType };

//# sourceMappingURL=maitred_activity_update_type.js.map